import { Dashboard } from "@stories/pages/Contractor/Dashboard/Dashboard";

export const DashboardView = () => {
  return <Dashboard />;
};
